import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertTriangle, Lock, StopCircle } from 'lucide-react';
import { DurationMode } from '@/store/ab-test/types';

interface FinalizeTestAlertProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  durationMode?: DurationMode;
}

export function FinalizeTestAlert({
  open,
  onOpenChange,
  onConfirm,
  durationMode = 'manual'
}: FinalizeTestAlertProps) {
  useLanguage();
  const handleConfirm = () => {
    onConfirm();
    onOpenChange(false);
  };

  const isAutomatic = durationMode === 'automatic';

  const title = isAutomatic ? translateInterfaceText("Finalizar agora?") : translateInterfaceText("Finalizar teste A/B?");
  const description = isAutomatic
    ? translateInterfaceText("Isso encerra o teste antes do término agendado e o tráfego volta para a VSL Principal. Esta ação não pode ser desfeita.")
    : translateInterfaceText("Ao finalizar, o tráfego volta para a VSL Principal. Esta ação não pode ser desfeita.");
  const buttonText = isAutomatic ? 'Finalizar Agora' : 'Finalizar Teste';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className='mb-0'>
          <DialogTitle className="flex items-center gap-2">
            {isAutomatic ? (
              <StopCircle className="h-5 w-5 text-destructive" />
            ) : (
              <Lock className="h-5 w-5 text-destructive" />
            )}
            {title}
          </DialogTitle>
          <DialogDescription className='!mt-4'>
            {description}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="flex gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {translateInterfaceText("Cancelar")}</Button>
          <Button variant="destructive" onClick={handleConfirm}>
            {buttonText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
